// extracted by mini-css-extract-plugin
export default {"header":"PartsTable_header__1udY2","body":"PartsTable_body__aXATu","error":"PartsTable_error__g-fWy"};